export default "__VITE_ASSET__37997214__"